const getters = {
    token: state => state.user.token,
    avatar: state => state.user.avatar,
    loginName: state => state.loginName,
    cartList: state => state.cartList,
    orderList: state => state.orderList,
    stratetyList: state => state.stratetyList,
    sheetList: state => state.sheetList,
    token: state => state.token,
    isLogin: state => state.isLogin,
    isStatement: state => state.isStatement,
    introduction: state => state.user.introduction,
    status: state => state.user.status,
    roles: state => state.user.roles,
    setting: state => state.user.setting,
}
export default getters


// WEBPACK FOOTER //
// ./src/store/getters.js